import { Plus } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useAuth } from '@/hooks/useAuth'
import { Permissions } from '@/lib/permissions'

interface ProjectsHeaderProps {
  onCreateProject: () => void
}

export function ProjectsHeader({ onCreateProject }: ProjectsHeaderProps) {
  const { hasPermission } = useAuth()

  return (
    <div className="flex items-center justify-between">
      <h1 className="text-3xl font-bold">Projects</h1>
      {hasPermission(Permissions.Host.Project.Create) && (
        <Button
          onClick={onCreateProject}
        >
          <Plus className="h-4 w-4" />
          New Project
        </Button>
      )}
    </div>
  )
}
